import { render, staticRenderFns } from "./Generator.vue?vue&type=template&id=070be439&"
import script from "./Generator.vue?vue&type=script&lang=ts&"
export * from "./Generator.vue?vue&type=script&lang=ts&"
import style0 from "./Generator.vue?vue&type=style&index=0&id=070be439&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports